import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from '../locales/en.json';
import sk from '../locales/sk.json';
import de from '../locales/de.json';
import es from '../locales/es.json';
import zh from '../locales/zh.json';
import cs from '../locales/cs.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      sk: { translation: sk },
      de: { translation: de },
      es: { translation: es },
      zh: { translation: zh },
      cs: { translation: cs },
    },
    fallbackLng: 'sk',
    detection: {
      order: ['localStorage'],
      lookupLocalStorage: 'tri2fly-lang',
      caches: ['localStorage'],
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
